import { usePayPointsQuery } from "Api/Queries/PayPoints/usePayPointsQuery";
import { FilterDropdown } from "Components/Shared/Components/FilterDropdown";
import type { FilterOption } from "Components/Shared/Filters/FilterOption";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.Shared.Filters;

type Props = {
  value: FilterOption | undefined;
  onChange: (option: FilterOption | undefined) => void;
};

export const PayPointFilterDropdown = ({ value, onChange }: Props) => {
  const { t } = useResource();

  const { data: payPointsData, isLoading } = usePayPointsQuery(0, 100);

  const options = [
    { value: "", label: t(PageResources.AllPayPoints) },
    ...(payPointsData?.items?.map(({ publicID, name }) => ({
      value: publicID ?? "",
      label: name ?? publicID ?? "",
    })) ?? []),
  ];

  const handleChange = (newValue: string | number) => {
    const selectedPublicID = newValue as string;
    if (!selectedPublicID) {
      onChange(undefined);
      return;
    }

    const { label = "" } =
      options.find(({ value }) => value === selectedPublicID) ?? {};

    onChange({ publicID: selectedPublicID, label });
  };

  return (
    <FilterDropdown
      label={t(PageResources.PayPoint)}
      options={options}
      value={isLoading ? "" : (value?.publicID ?? "")}
      onChange={handleChange}
      disabled={isLoading}
      placeholder={t(PageResources.AllPayPoints)}
    />
  );
};
